import { useNavigate } from "react-router-dom";
import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { Box } from "@financeable-com-au/financeable-ui";
import { REPORTING_NAV_ITEMS } from "@/constants";

const ReportingSidebar = ({
  path,
  canViewCommissionReport,
  canViewApplicationsDataReport,
}: {
  path: string;
  canViewCommissionReport: boolean;
  canViewApplicationsDataReport: boolean;
}) => {
  const navigate = useNavigate();
  const reportingNavItems = REPORTING_NAV_ITEMS.filter(
    (route) =>
      (!route.requiresCommissionAccess || canViewCommissionReport) &&
      (!route.requiresOwnerOrAdminAccess || canViewApplicationsDataReport),
  );

  return (
    <>
      <Box sx={{ width: "100%", fontSize: "10px" }}>
        <List>
          {reportingNavItems.map((route) => (
            <ListItem disablePadding dense key={route.path}>
              <ListItemButton selected={path === route.path} onClick={() => navigate(`/reporting/${route.path}`)}>
                <ListItemText
                  primary={route.label}
                  primaryTypographyProps={{
                    fontSize: "13px",
                    fontWeight: path === route.path ? 700 : 400,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
};

export default ReportingSidebar;
